// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Vh158","terms":"Footer_terms__NO5lu","company_box":"Footer_company_box__hXP2q","copyrite":"Footer_copyrite__279vr"};